import { useEffect, useState } from "react";
import { Hero } from "@/components/Hero";
import { GenreMarquee } from "@/components/GenreMarquee";
import { Catalog } from "@/components/Catalog";
import { ContinueWatching } from "@/components/ContinueWatching";
import { BrandBanner } from "@/components/BrandBanner";
import { AdUnit } from "@/components/AdUnit";
import { api } from "@/lib/api";

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [genres, setGenres] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.get("/anime").then((r) => {
      setTotal(r.data.length);
      const f = r.data.filter((a) => a.featured);
      setFeatured(f.length ? f : r.data.slice(0, 3));
    });
    api.get("/genres").then((r) => setGenres(r.data));
  }, []);

  return (
    <main data-testid="home-page">
      <Hero featured={featured} total={total} />
      <GenreMarquee genres={genres} />
      <BrandBanner />
      <ContinueWatching />

      <div className="py-28">
        <Catalog title="All Anime" />
      </div>

      <AdUnit testId="ad-unit-home" />

    </main>
  );
}
